<div class="container" dir="rtl">
  <div *ngIf="report?.EngineHealthScore">
    <ng-container *ngIf="report?.EngineHealthScore !== -1">
      <div class="report-card">
        <p class="report-text text-center">{{report?.ProblemCategory}}</p>
        <div class="score-section py-4">
          <div class="score-number">
            <small>100 /</small>
            {{ report?.EngineHealthScore }}
          </div>

          <div class="progress-track">
            <div class="progress-fill" [style.width.%]="report?.EngineHealthScore"></div>
          </div>

          <div class="text-center pt-4">
            <span
              class="status-badge"
              [ngClass]="{
                'good': report?.EngineHealthScore >= 70,
                'medium': report?.EngineHealthScore >= 40 && report?.EngineHealthScore < 70,
                'bad': report?.EngineHealthScore < 40
                }">
              {{ report?.HealthLevel }}
            </span>
          </div>
        </div>

        <div class="report-section">
          <h3>گزارش تحلیل</h3>
          <div class="report-text">
            {{ report?.DiagnosticReport }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
